module.exports = {
  config:{
    agent_verification:true
  },
  path: [
    // {
    //   "type": "agent_liveness",
    //   "link": "/agent-verification"
    // },
    {
      "type": "customer_liveness",
      "link": "/detect-face"
    },
    {
      "type": "document_detection",
      "link": "/detect-document",
      "reference_frame": true,
      "back_frame": false,
      "authentication_frames": 10
    },
    {
      "type": "personal_info_verification",
      "link": "/info-verification"
    },
    {
      "type": "mobile_number_verification",
      "link": "/mobile-verification"
    },
    {
      "type": "undertaking",
      "link": "/undertaking"
    },
    {
      "type": "account_selection",
      "link": "/account-options"
    },
    {
      "type": "complete_page",
      "link": "/complete-page"
    },
  ]
}
